import { Outlet, useLocation } from "react-router-dom";

import { Header } from "@/components/common";
import styles from "./AppLayout.module.scss";

export function AppLayout() {
  const { pathname } = useLocation();
  const isMonitor = ["/app", "/settings", "/support"].includes(pathname);

  return (
    <div
      className={`${styles.layout} ${isMonitor ? styles.monitorLayout : ""}`}
    >
      <Header />
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
